import {CancellationService} from '../../services/cancellation.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface CancellationReason {
  id: number;
  description: string;
  refers_to: any;
}

@Component({
  templateUrl: 'cancellation-accessory-loading-dialog.component.html'
})

export class CancellationAccessoryLoadingDialogComponent implements OnInit {
  commandId: number;
  isLoading: boolean;
  reasons: CancellationReason[] = [];
  selectedReason: CancellationReason;

  constructor(private cancellationService: CancellationService,
              private matDialogRef: MatDialogRef<CancellationAccessoryLoadingDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.commandId = this.data.id;
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.reasons = await this.cancellationService.getCancelReasons('refers_to=1');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις αιτίες ακύρωσης');
    }
  }

  close(value?: boolean) {
    this.matDialogRef.close(value);
  }

  async cancel() {
    try {
      this.isLoading = true;
      const model = {
        cancel_reason_id: this.selectedReason.id,
        command_id: this.commandId
      };
      await this.cancellationService.cancelAccessoryLoadingOrder(model);
      this.close(true);
    } catch (e) {
      this.isLoading = false;
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ακυρώσουμε την εντολή');
    }
  }

  isButtonDisabled() {
      return !this.selectedReason;
  }
}
